<template>
  <div id="video-Box" class="clearfloat">
    <div id="video-list" ></div>
  </div>

</template>

<style>
  .clearfloat:after{display:block;clear:both;content:"";visibility:hidden;height:0} 
  .clearfloat{zoom:1;} 
  .stream1{ 
    cursor: pointer;
    margin:0 4px;
    margin-top: 25px;
    position: relative;
    width: 300px;
    height:177px; 
  }
  .float{
    float: left;
  }
  #video-list{
    overflow: auto;
    height:900px;
  } 
  .stream{
    /*position: absolute;
    z-index: 5555;*/
  }
  .video-info{ 
    position: absolute;
    z-index: 5558;
    top: -21px;
    width: 100%;
    background: #eee;
    padding-left: 10px;
  }
  .video-info span{
    font-weight: 600!important;
  }
  .load{
    position: absolute; 
    background: #000!important;
    color:#fff;
  }
  .loading{
    width:84px;
    height:84px;
  }
  .record{
    position: absolute;
    bottom:5px;
    right:5px;
  }
</style>
<script>  
  import store from '@/store' 
  export default { 
    data() {
      return {
        connection:null, 
        showPlayMask:false,
        teamMemberLists:[],
        flag:true
      }
    },
    created(){

    },
    mounted() {  
      let html = ''
      let data = [] 
      let that = this

      if(sessionStorage.getItem("videoTeamMemberLists")){
        data =  JSON.parse(sessionStorage.getItem("videoTeamMemberLists"))
      }else{
        sessionStorage.setItem("videoTeamMemberLists", JSON.stringify(this.$store.state.TeamMemberLists))
        data = this.$store.state.TeamMemberLists 
      }
 
 
 


      for (var i = 0; i < data.length; i++) {
        if(data[i].isOnLine == false){



          this.teamMemberLists.push(data[i]) 
          html += `<div class="stream1 float" sn=`+data[i].SN.substring(2)+`>
                                <div class="video-info">
                                  <span>`+data[i].Name+`</span>
                                  <span class="video-sound">
                                    <a-icon type="sound"/>
                                  </span>
                                </div>  
                                <div class="load">
                                    <div class="loading"></div>
                                    <div class="OpenVideo"></div>
                                    <div class="msg">对方暂无视频</div>
                                </div> 
                                <div class="stream" id="stream`+data[i].SN.substring(2)+`"></div>
                                <div class="record" style="display:none"></div> 
                              </div> ` 
        }
      } 

      if(html == ''){
        document.getElementById('video-list').innerHTML = '<div style="text-align: center;font-size: 20px;margin-top: 100px;color:#fff;">暂无上线队员</div>' 
      }else{
        document.getElementById('video-list').innerHTML = html
      }
      



       
      var roominit = {}
// setup logging stuffs
TRTC.Logger.setLogLevel(TRTC.Logger.LogLevel.NONE);
TRTC.Logger.enableUploadLog();
var sn;
var token;
var ConnectionId;
var stream1;

var client;

 

function createClientOrJoin() {  
    client = TRTC.createClient({
        mode: 'rtc',
        sdkAppId: roominit.sdkAppId,
        userId: roominit.userId,
        userSig: roominit.userSig
    });
    client.on('stream-added', event => {
        const remoteStream = event.stream;
        var userid = remoteStream.getUserId(); 
        console.log('远端流增加: ' + userid) 
        client.subscribe(remoteStream);  
    });
    client.on('stream-removed', event => {
        const remoteStream = event.stream;
        var userid = remoteStream.getUserId();   
        console.log('远端流取消: ' + userid);
 

        for (let i = 0; i < stream1.length; i++) {
          if(stream1[i].getAttribute('sn') == userid){  
            stream1[i].getElementsByClassName('load')[0].style.display = "flex";
            stream1[i].getElementsByClassName('msg')[0].innerHTML = '正在关闭视频请稍后'
            try {
                remoteStream.stop(); 
            } catch(e) {
                 
            } finally {
                
            } 
          }
        }

    });
    client.on('stream-subscribed', event => {
        const remoteStream = event.stream;
        var userid = remoteStream.getUserId(); 
       
        console.log('远端流订阅成功：' + userid);

        for (let i = 0; i < stream1.length; i++) {
          if(stream1[i].getAttribute('sn') == userid){
            stream1[i].getElementsByClassName('load')[0].style.display = "none";

           /* var bl = remoteStream.muteAudio();
            console.log('取消音频流', bl);*/
            // 播放远端流 
            document.getElementById("stream"+userid).innerHTML = '' 
            try { 
                remoteStream.play("stream"+userid);
            } catch(e) {
                 
            } finally {
                
            }
            

          }
        }
 

    });
    //加入房间
    client.join({ roomId: parseInt(roominit.roomId) })
        .catch(error => {
            console.error('进房失败 ' + error);
        })
        .then(() => {
            console.log('进房成功');
        });
}
function ClientLeave() {
    if (client) {
        client
            .leave()
            .then(() => {
                console.info('退房成功');
                // 退房成功，可再次调用client.join重新进房开启新的通话。
            })
            .catch(error => {
                console.error('退房失败 ' + error);
                // 错误不可恢复，需要刷新页面。
            });
        client = null;
    }
}
///ES6
Number.prototype.isInteger = function (global) {
    var floor = Math.floor,
        isFinite = global.isFinite;

    Object.defineProperty(Number, 'isInteger', {
        value: function isInteger(value) {
            return typeof value === 'number' &&
                isFinite(value) &&
                floor(value) === value;
        },
        configurable: true,
        enumerable: false,
        writable: true
    });
};

///获取url参数
function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) { return pair[1]; }
    }
    return (false);
}
var url = "/rtcmsg"

var connection = new signalR.HubConnectionBuilder().withUrl(url).build();

connection.keepAliveIntervalInMilliseconds = 12e4;
connection.serverTimeoutInMilliseconds = 24e4;

 
    sn = this.teamMemberLists[0] && this.teamMemberLists[0].SN  

    token = '8bc7e2b6-83b4-4b6b-bdea-82c4de0108bc'  
    if (sn && token) {
      if (!Number.isInteger(Number(sn))) {
          sn = sn.substring(2);
      } 
      signalRInit();
      signalRStart(); 
    } else {
      //document.getElementById('loading').style.display = "none";
      //document.getElementById('msg').innerHTML = "参数错误";
    }
     
    function signalRStart() {
        connection.start().then(function () { 
            connection.invoke("Login", "monitor", sn, token).catch(function (err) {
                console.error(err.toString());
            }); 
        }).catch(function (err) {
            setTimeout(() => {
                console.error("连接不上:", err.message);
                signalRStart();

            }, 5000)
        });
    } 


    stream1 = document.getElementsByClassName('stream1')
    function signalRInit() { 

        connection.on("error", function (type, message) {
            document.getElementById('loading').style.display = "none";
            document.getElementById('msg').innerHTML = message;
            console.error(type, message);
        });

        connection.onclose(async () => {
            console.error("断开连接");
            setTimeout(() => {
                signalRStart();

            }, 5000)
        });
        connection.on("SDKSig", function (type, json) { 
            if (typeof json == "string") {
                json = JSON.parse(json);
            } 
            roominit = json;
 
        })
        connection.on("info", function (type, sn1, name, ConnectionId2) { 
            switch (type) {
                case 1100:
                case 1001: 
                    for (let i = 0; i < stream1.length; i++) {
                      if(stream1[i].getAttribute('sn') == sn1){ 
                        stream1[i].setAttribute('connectionid',ConnectionId2)
                        stream1[i].getElementsByClassName('loading')[0].style.display = "none";
                        stream1[i].getElementsByClassName('msg')[0].innerHTML = "对方视频暂未打开";
                        stream1[i].getElementsByClassName('OpenVideo')[0].style.display = "block"; 
                      }
                    }  
                    break;
                case 1002: 
                    /*for (let i = 0; i < stream1.length; i++) { 
                      setTimeout(()=>{
                        if(stream1[i].getElementsByClassName('msg')[0].innerHTML == "对方暂无视频"){
                          stream1[i].getElementsByClassName('loading')[0].style.display = "none";
                          stream1[i].getElementsByClassName('load')[0].style.display = "flex";
                          stream1[i].getElementsByClassName('msg')[0].innerHTML = "当前队员不在线"; 
                          stream1[i].getElementsByClassName('OpenVideo')[0].style.display = "none";
                          stream1[i].getElementsByClassName("record")[0].style.display = "none"; 
                        } 
                      },2000) 
                    }*/
                  break;


                case 2000: 
                    for (let i = 0; i < stream1.length; i++) {
                      if(stream1[i].getAttribute('connectionid') == ConnectionId2){ 
                        stream1[i].getElementsByClassName('loading')[0].style.display = "none";
                        stream1[i].getElementsByClassName('load')[0].style.display = "flex";
                        stream1[i].getElementsByClassName('msg')[0].innerHTML = "当前队员不在线"; 
                        stream1[i].getElementsByClassName('OpenVideo')[0].style.display = "none";
                        stream1[i].getElementsByClassName("record")[0].style.display = "none";
                      }
                    }
                       
                    //ClientLeave();
                    
                    break;
                case 1200:  
                    var param = JSON.parse(sn1);  

                    if (param.IsVideoOpen) {
                      if(that.flag) { 
                        createClientOrJoin();  
                        that.flag=false
                      }

                      for (let i = 0; i < stream1.length; i++) {
                        if(stream1[i].getAttribute('sn') == param.SN){     
                          stream1[i].getElementsByClassName('msg')[0].innerHTML = "正在打开视频请稍后"; 
                          stream1[i].getElementsByClassName("record")[0].style.display = "flex";
                          if(param.IsVideoRecord){
                            stream1[i].getElementsByClassName("record")[0].style.backgroundImage = 'url("Player/img/record_close.png")';
                          }else{
                            stream1[i].getElementsByClassName("record")[0].style.backgroundImage = 'url("Player/img/record_open.png")';
                          }
                        }
                      }
                    } else {   
                      for (let i = 0; i < stream1.length; i++) {
                        if(stream1[i].getAttribute('sn') == param.SN){   
                          stream1[i].getElementsByClassName("record")[0].style.display = "none";
                          stream1[i].getElementsByClassName('load')[0].style.display = "flex";
                          stream1[i].getElementsByClassName('loading')[0].style.display = "none";
                          stream1[i].getElementsByClassName('msg')[0].innerHTML = "对方视频暂未打开";
                          stream1[i].getElementsByClassName('OpenVideo')[0].style.display = "block";
                        }
                      } 
                      //ClientLeave();
                    }

                    break;
            }
            //console.info(type, sn1, name, ConnectionId2);
        })
    }


    for (let i = 0; i < stream1.length; i++) { 
      stream1[i].getElementsByClassName("OpenVideo")[0].onclick = function () { 
        //console.log("打开视频", 1004, sn, ConnectionId);
        stream1[i].getElementsByClassName('msg')[0].innerHTML = "正在打开视频请稍后";
        stream1[i].getElementsByClassName('OpenVideo')[0].style.display = "none";
        //打开视频 
        connection.invoke("Instruct", 1004, stream1[i].getAttribute('sn'), stream1[i].getAttribute('connectionid'), null).catch(function (err) {
            console.error(err.toString());
        });
        stream1[i].getElementsByClassName("record")[0].style.display = "flex";
      
           
      }
    }


    let mainWidth = document.getElementsByClassName('maple-content')[0].offsetWidth 
    let mainHeight = document.getElementsByClassName('maple-content')[0].offsetHeight
    for (let i = 0; i < stream1.length; i++) { 
      stream1[i].ondblclick = function () {  
          if(stream1[i].offsetWidth>300){
            for (let j = 0; j < stream1.length; j++) { 
              stream1[j].removeAttribute('style') 
            }
          }else{
            document.getElementById('video-list').style.height=mainHeight+'px'
            for (let j = 0; j < stream1.length; j++) {
              stream1[j].style.width= '300px'
              stream1[j].style.minHeight = '177px'
              stream1[j].style.height='177px'  
              stream1[j].style.position='relative'
              stream1[j].style.marginLeft=mainWidth-320+'px'
            } 
            stream1[i].style.position='absolute'
            stream1[i].style.marginTop='25px' 
            stream1[i].style.top='0'
            stream1[i].style.width= mainWidth-340+'px' 
            stream1[i].style.minHeight= (mainWidth-340)/1.7 +'px'
            stream1[i].style.height='auto'
            stream1[i].style.marginLeft='0'
          } 
      }
    }
    

 

    for (let i = 0; i < stream1.length; i++) { 
      stream1[i].getElementsByClassName("record")[0].onclick = function () {
        let backgroundImage = stream1[i].getElementsByClassName("record")[0].style.backgroundImage  
        let sn = stream1[i].getAttribute('sn')
        let connectionId = stream1[i].getAttribute('connectionid')  
        console.log(backgroundImage.indexOf('close') != -1)
        if(backgroundImage.indexOf('close') != -1){  
          console.log("关闭录制", 1015, sn, connectionId);
          connection.invoke("Instruct", 1015, sn, connectionId, null).catch(function (err) {
              console.error(err.toString());
          });
          stream1[i].getElementsByClassName("record")[0].style.backgroundImage = 'url("Player/img/record_open.png")';
        }else{
          console.log("打开录制", 1014, sn, connectionId);
          connection.invoke("Instruct", 1014, sn, connectionId, null).catch(function (err) {
              console.error(err.toString());
          });
          stream1[i].getElementsByClassName("record")[0].style.backgroundImage = 'url("Player/img/record_close.png")';
        } 
      }

    }
  },
  beforeDestroy(){
    sessionStorage.removeItem("videoTeamMemberLists")

  }

}
  
 
</script>


<style scoped>
.video-enlarge {
  position: fixed;
  width: auto !important;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  max-width: 100vw;
  max-height: 100vh;
  text-align: center !important;
  background-color: rgba(0, 0, 0, 0.45);
  z-index: 9999;
}
.video-enlarge::before {
  display: inline-block;
  width: 0;
  height: 100%;
  vertical-align: middle;
  content: "";
}
.stream-magnify {
  width: 480px !important;
}
.video-info {
  position: absolute;
  top: 0;
  width: 100%;
  padding: 4px 6px;
  z-index: 1000;
  background-color: #c8c8c8a8;
  font-size: 14px;
  color: #fff;
}
.video-info .video-sound {
  float: right;
  color: springgreen;
}
.video-ping {
  position: absolute;
  top: 28px;
  left: 10px;
  z-index: 1000;
  font-size: 12px;
  color: #fff;
}
.video-videoloss {
  position: absolute;
  top: 44px;
  left: 10px;
  z-index: 1000;
  font-size: 12px;
  color: #fff;
}
.video-audioloss {
  position: absolute;
  top: 60px;
  left: 10px;
  z-index: 1000;
  font-size: 12px;
  color: #fff;
}
.video-picture {
  position: absolute;
  bottom: 24px;
  left: 50%;
  margin-left: -18px;
  z-index: 1000;
  font-size: 24px;
  color: rgb(63, 219, 35, 0.5);
  background-color: transparent;
  border: 2px solid rgb(63, 219, 35, 0.5);
  width: 40px;
  height: 40px;
}
.media-player {
  display: inline-block;
  margin: 2px 4px;
  width: 300px;
  text-align: left;
  white-space: nowrap;
  cursor: pointer;
}

.media-player .video-container {
  position: relative;
}

.media-player .muted-mask,
.media-player .play-mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
  opacity: 0.6;
  background-color: #1f2730;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.muted-mask .mask-content,
.play-mask .mask-content {
  max-width: 200px;
}

.mask-content .hint {
  margin-bottom: 12px;
  white-space: break-spaces;
  font-size: 14px;
}

.mask-content button {
  min-height: 50px;
  min-width: 50px;
}

.media-player video {
  width: 100%;
  height: 100%;
}
</style>